import { render, staticRenderFns } from "./ReceiptTypeForm.vue?vue&type=template&id=1855e67e&scoped=true"
import script from "./ReceiptTypeForm.vue?vue&type=script&lang=ts"
export * from "./ReceiptTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855e67e",
  null
  
)

export default component.exports